import { voucherRepository } from "@/service/repository/voucherRepository";

const state = {
    voucherSets: [],
    currentVoucherSet: null,
    isLoading: false,
    error: null
};

const mutations = {
    setVoucherSets(state, voucherSets) {
        state.voucherSets = voucherSets;
    },
    setCurrentVoucherSet(state, voucherSet) {
        state.currentVoucherSet = voucherSet;
    },
    setLoading(state, isLoading) {
        state.isLoading = isLoading;
    },
    setError(state, error) {
        state.error = error;
    },
    addVoucherSet(state, voucherSet) {
        state.voucherSets.push(voucherSet);
    }
};

const actions = {
    async createVoucherSet({ commit }, voucherSetData) {
        commit('setLoading', true);
        commit('setError', null);
        
        try {
            const response = await voucherRepository.createVoucherSet(voucherSetData);
            
            if (response && response.result === 0) {
                commit('addVoucherSet', response.voucherSet);
                commit('setCurrentVoucherSet', response.voucherSet);
                return response;
            } else {
                commit('setError', response?.message || 'Unknown error');
                return response;
            }
        } catch (error) {
            commit('setError', error.message);
            throw error;
        } finally {
            commit('setLoading', false);
        }
    }
};

const getters = {
    voucherSets: state => state.voucherSets,
    currentVoucherSet: state => state.currentVoucherSet,
    isLoading: state => state.isLoading,
    error: state => state.error
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}; 